export const PLOT_GRID_INDEX = 0;
export const TRACK_GRID_INDEX = 1;
export const PLOT_X_AXIS_INDEX = 0;
export const TRACK_X_AXIS_INDEX = 1;

/** Pixel geometry of the chart regions. Everything here is renderer-internal. */
export const chartLayout = {
  /** Left and right inset of both grids; sharing it keeps the plot's and the track's time axes aligned. */
  gridSideInset: 12,
  plotTop: 32,
  /** Room for one row of time labels right under the plot. */
  timeAxisHeight: 24,
  trackLaneHeight: 24,
  /** Gap after the plot's time labels, before the optional header or the track itself. */
  trackTopGap: 4,
  /** Header row between the plot's time axis and the range-track lanes. */
  rangeTrackHeaderHeight: 32,
  /** Space kept below the track for the slider when navigation is enabled. */
  navigationReservedHeight: 40,
  /** Section-title positions are independent so each can be tuned to the design. */
  sectionLabelPositions: {
    plot: { left: 12, top: 0 },
    /** Added to the bottom position derived from the track and its header row. */
    rangeTrack: { left: 6, bottomOffset: 0 },
  },
  /** The vertical line on which each range-track lane marker starts. */
  trackLabelMarkerLeft: 6,
  /** Highlighted lane rows start at the chart's edge, so the row frames the marker with room to spare. */
  rowHighlightLeft: 0,
  sliderHeight: 24,
  /** Horizontal insets of the navigation slider, tuned to the design; the right one leaves room for the end handle. */
  sliderInset: { left: 0, right: 14 },
  sliderBottom: 8,
} as const;
